import { render, staticRenderFns } from "./ClientSearches.vue?vue&type=template&id=de1f53bc&scoped=true"
import script from "./ClientSearches.vue?vue&type=script&lang=js"
export * from "./ClientSearches.vue?vue&type=script&lang=js"
import style0 from "./ClientSearches.vue?vue&type=style&index=0&id=de1f53bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1f53bc",
  null
  
)

export default component.exports